<template>
    <div class="fullscreen">
        <router-view />
    </div>
</template>

<script>
import { useRosterStore } from "@/stores/index";

export default {
    name: "App",
    data() {
        return {
            store: useRosterStore(),
        };
    },
    methods: {
        applyTheme(themeNumber) {
            const id = "theme-style";
            const href =
                themeNumber === 1 ? "/theme-core.css" : "/theme-gothic.css";

            let link = document.getElementById(id);
            if (!link) {
                link = document.createElement("link");
                link.id = id;
                link.rel = "stylesheet";
                document.head.appendChild(link);
            }

            link.href = `${href}`;
        },
    },
    watch: {
        "store.theme": {
            handler(newVal) {
                this.applyTheme(newVal);
            },
            immediate: true,
        },
    },
};
</script>

